















































import mixins from 'vue-typed-mixins';
import UserUtils, { User } from '@/utils/UserUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  props: {
    user: {
      type: Object as () => User,
    },
  },

  data(): {
    visible: boolean;
    password: string;
    setResetPasswordState: boolean;
  } {
    return {
      visible: false,
      password: '',
      setResetPasswordState: true,
    };
  },

  methods: {
    handleClick() {
      this.visible = true;
    },

    generate() {
      // not perfect, generates a 10 character string where the first half is lowercase/digits and second half is upper/digits
      this.password =
        Math.random()
          .toString(36)
          .slice(2, 8) +
        Math.random()
          .toString(36)
          .slice(2, 8)
          .toUpperCase();
      (this.$refs.validation as any).validate(this.password); // force validation
    },

    async submit() {
      try {
        if (this.user) {
          const user = cloneDeep(this.user);
          user.password = this.password;
          user.state = this.setResetPasswordState
            ? 'reset_password'
            : user.state;

          await UserUtils.api.update(user);

          this.$emit('update', {
            // password: user.password, // password should never be set on the user
            state: user.state,
          });

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('page.user.details.resetPassword.success'),
          });

          this.exit();
        }
      } catch (error) {
        this.$alert.show('set', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },

    exit() {
      this.visible = false;
      this.password = '';
      this.setResetPasswordState = true;
    },
  },
});
